export const ProfessionalWorkStatus = {
  RANKINGS: "Rankings",
  UPCOMING: "All",
  NEW_TO_WORKPLACE: "New to your workplace",
  IN_PROGRESS: "In Progress",
  BLOCKED: "Blocked",
  PAST: "Past",
  STARRED: "Starred",
};

export const DefaultATeamRosterSize = 5;

export const DEFAULT_TOAST_AUTO_HIDE_DURATION_IN_MILLISECONDS = 8000;

export const A_TEAM_COLOR = "#1890FF";
